var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0312 8V8.65625H8.75V9.96875H9.40625V18.5C9.40625 19.2249 9.99388 19.8125 10.7188 19.8125H17.2812C18.0061 19.8125 18.5938 19.2249 18.5938 18.5V9.96875H19.25V8.65625H15.9688V8H12.0312ZM12.0312 11.2812H13.3438V17.1875H12.0312V11.2812ZM14.6562 11.2812H15.9688V17.1875H14.6562V11.2812Z",
    fill: "#3A4669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.3a96f3d65ca2e5d3e714c3c75eaee8f9.svg";
export { ForwardRef as ReactComponent };